import { Theme } from '@mui/material';

export const inputSx = (theme: Theme) => ({
  width: '100%',
  '& .MuiInput-underline:before': { borderBottomColor: 'transparent' },
  '& .MuiInput-underline:hover:before': { borderBottomColor: theme.palette.primary.main },
  '& input': {
    color: theme.palette.primary.main,
    textAlign: 'right' as const,
    fontSize: '0.8rem',
  },
});

export const inputSlotProps = {
  htmlInput: { style: { textAlign: 'right' as const, fontSize: '0.8rem' } },
};

export const tableStyle = (theme: Theme) => ({
  borderCollapse: 'collapse' as const,
  width: '100%',
  border: `1px solid ${theme.palette.divider}`,
});
